import { render, staticRenderFns } from "./SubmitTarget.vue?vue&type=template&id=4395fb2c"
import script from "./SubmitTarget.vue?vue&type=script&lang=js"
export * from "./SubmitTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports